import React, { useState, useEffect } from "react";
import "./dashboard.scss";
import OffersChart from "./OffersChart";
import { useDispatch } from "react-redux";
import { getAdminOfferStats } from "../../../services/adminService";
import { Select } from "antd";
import { ReactComponent as DownArrow } from "../../../Assets/Icons/greyDownArrow.svg";

const FILTER_OPTIONS = [
  { label: "Today",      value: "today"     },
  { label: "Year",       value: "year"      },
  { label: "This Month", value: "thismonth" },
  { label: "Last Month", value: "lastmonth" },
  { label: "Last Week",  value: "lastweek"  },
];

const AdminDetailDashboard = ({ selectedFrequency }) => {
  const dispatch = useDispatch();
  const [offerTimeframe, setOfferTimeframe] = useState("year");

  // Fetch on mount with default timeframe
  useEffect(() => {
    dispatch(getAdminOfferStats({ timeframe: offerTimeframe }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOfferTimeframeChange = (tf) => {
    if (tf === offerTimeframe) return;
    setOfferTimeframe(tf);
    dispatch(getAdminOfferStats({ timeframe: tf }));
  };

  return (
    <div className="summary w-full h-full p-4 offersChart" style={{ minHeight: "200px" }}>
      {/* Header row: title on left, dropdown on right */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full gap-3 mb-4">
        <span className="text-[20px] font-poppins font-[600] text-[black] whitespace-nowrap">
          Offers Summary
        </span>

        <div className="flex items-center gap-3">
          {/* Internal timeframe dropdown — independent of global frequency */}
          <Select
            value={offerTimeframe}
            onChange={handleOfferTimeframeChange}
            className="border border-[#00ADEF] rounded-md pr-3 text-[14px] font-poppins font-[500] text-gray-600 outline-none h-[40px] flex items-center"
            suffixIcon={<DownArrow />}
            options={FILTER_OPTIONS}
            dropdownMatchSelectWidth={false}
            style={{ minWidth: "120px" }}
          />
        </div>
      </div>

      <OffersChart className="sm:mt-[3%] 2xl:mt-[1%]" />
    </div>
  );
};

export default AdminDetailDashboard;

